export const BitcoinInitialData = {
  payload: {
    name: "",
    crypto_currency: "bitcoin",
    receiver: "",
    amount: "",
    message: "",
  },
};
